export default {
  data() {
    return {
      searchSchema: [
        {
          label: '预警信息类型',
          type: 'select',
          itemName: 'type',
          selectList: [
            { text: '限额超担保', value: 1 },
            { text: '限额超保险', value: 2 },
          ],
          allowClear: true,
        },
        {
          label: '业务类型选择',
          type: 'select',
          itemName: 'businessId',
          selectList: [],
          placeholder: '全部',
          handleChange: this.handleModelChange,
          allowClear: true,
        },
        {
          label: '业务模式',
          itemName: 'modelId',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
      ],
      searchData: {
        type: '',
        modelId: '',
        businessId: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '预警信息类型',
          width: 120,
          dataIndex: 'typeStr',
        },
        {
          title: '业务类型',
          width: 140,
          dataIndex: 'business',
        },
        {
          title: '业务模式',
          width: 220,
          dataIndex: 'model',
        },
        {
          title: '编辑时间',
          width: 180,
          dataIndex: 'updateTime',
        },
        {
          title: '编辑人名称',
          width: 180,
          dataIndex: 'username',
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchData = { ...this.searchData, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
